module.exports = __webpack_public_path__ + "static/media/epiglow-2.f0ba7740.jpg";